
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["mx-auto",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"25","height":"25","viewBox":"0 0 29 29","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.497 28.425c7.692 0 13.928-6.236 13.928-13.928C28.425 6.805 22.19.569 14.497.569 6.805.569.569 6.805.569 14.497c0 7.692 6.236 13.928 13.928 13.928z","fill":"#fff","stroke":"#000","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M14.497 25.267c5.948 0 10.77-4.822 10.77-10.77 0-5.948-4.822-10.77-10.77-10.77-5.948 0-10.77 4.822-10.77 10.77 0 5.948 4.822 10.77 10.77 10.77z","fill":"#fff","stroke":"#000","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M14.497 3.727v2.958M14.497 22.314v2.959","stroke":"#000","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M6.685 14.503H3.727","stroke":"#000","stroke-miterlimit":"10","stroke-linecap":"round"}}),_c('path',{attrs:{"d":"M25.273 14.503h-2.959","stroke":"#000","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M13.189 13.08l6.372-3.476-3.442 6.407-6.685 3.749 3.755-6.68z","fill":"#fff","stroke":"#000","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M13.188 13.08l2.948 2.913","stroke":"#000","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    